// extracted by mini-css-extract-plugin
export default {"statBoxWrapper":"topIconStat_statBoxWrapper__7eTxF","statBoxContent":"topIconStat_statBoxContent__Fg9Qc","statBoxStat":"topIconStat_statBoxStat__PtC+G"};